import AssemblyCataloguePicture from "./AssemblyCataloguePicture";
import "../styles/product-assembly-catalogue.css";

/** Assembly instructions infographic on product detail — image only. */
export default function ProductAssemblyCatalogue() {
  return (
    <section className="product-assembly-catalogue" aria-label="Gift box assembly instructions">
      <AssemblyCataloguePicture className="product-assembly-catalogue__image" />
    </section>
  );
}
